import { ComparableProperty } from "@cma/presentation-generation-logic";
import { parseComparablePropertyType } from "@cma/presentation-generation-logic/shared/properties-map-utils";
import { PropertyDto } from "@cma/shared/apis/comps/cma/generated";

export const convertPropertyDtoToComparableProperty = (
  property: PropertyDto
): ComparableProperty => {
  return {
    id: property.id,
    mlsId: property.mlsId || "",
    mlsSource: property.mlsSource || "",
    addressLine1: property.addressLine1,
    addressLine2: property.addressLine2,
    city: property.city,
    area: property.area,
    neighborhood: property.neighborhood,
    propertyType: property.propertyType,
    type: parseComparablePropertyType(property.propertyType),
    listingStatus: property.listingStatus || null,
    yearBuilt: property.yearBuilt,
    livingSpace: property.livingSpace,
    beds: property.beds,
    baths: property.baths,
    lotSize: property.lotSize,
    garageParkingSpaces: property.garageSpaces,
    hoaFees: property.hoaFees,
    hoaFee: property.hoaFee,
    latitude: property.latitude,
    longitude: property.longitude,
    listDate: property.listDate,
    photos:
      property.images?.map((img) => ({
        id: img.id,
        url: img.url,
        caption: img.caption,
        thumbnail: img.cdnUrl,
      })) || [],
    zipCode: property.zipCode,
    state: property.state,
    costPerInternalSqFt: undefined,
    currentPrice: property.listPrice,
    soldPrice: property.soldPrice,
    soldDate: property.soldDate,
    hasDoormanAttendance: property.hasDoormanAttendance,
    isLease: property.isLease,
    roomsTotal: property.roomsTotal,
    recurringCosts:
      property.recurringCosts?.map((cost) => ({
        label: cost.label || "",
        value: cost.value,
        frequency: cost.frequency || "",
        type: cost.type || "",
      })) || null,
    flipTaxRemarks: property.flipTaxRemarks,
    description: property.description,
  };
};

export const convertComparablePropertyToPropertyDto = (
  property: ComparableProperty
): PropertyDto => {
  return {
    id: property.id,
    mlsId: property.mlsId || undefined,
    mlsSource: property.mlsSource || undefined,
    addressLine1: property.addressLine1 || undefined,
    addressLine2: property.addressLine2 || undefined,
    city: property.city || undefined,
    area: property.area || undefined,
    neighborhood: property.neighborhood || undefined,
    propertyType: property.propertyType || undefined,
    listingStatus: property.listingStatus || undefined,
    yearBuilt: property.yearBuilt || undefined,
    livingSpace: property.livingSpace || undefined,
    beds: property.beds || undefined,
    baths: property.baths || undefined,
    lotSize: property.lotSize || undefined,
    garageSpaces: property.garageParkingSpaces || undefined,
    hoaFees: property.hoaFees || undefined,
    hoaFee: property.hoaFee || undefined,
    latitude: property.latitude || undefined,
    longitude: property.longitude || undefined,
    listDate: property.listDate || undefined,
    images:
      property.photos?.map((photo) => ({
        id: photo.id,
        url: photo.url,
        caption: photo.caption || undefined,
        cdnUrl: photo.thumbnail || undefined,
      })) || [],
    zipCode: property.zipCode || undefined,
    state: property.state || "",
    listPrice: property.currentPrice || undefined,
    soldPrice: property.soldPrice || undefined,
    soldDate: property.soldDate || undefined,
    hasDoormanAttendance: property.hasDoormanAttendance || false,
    isLease: property.isLease || undefined,
    roomsTotal: property.roomsTotal || undefined,
    recurringCosts:
      property.recurringCosts?.map((cost) => ({
        label: cost.label,
        value: cost.value || undefined,
        frequency: cost.frequency,
        type: cost.type,
      })) || [],
    flipTaxRemarks: property.flipTaxRemarks || undefined,
    description: property.description || undefined,
    listingAgent: {
      name: null,
      dre: null,
      brokerage: null,
      lastSourceUpdateDate: null,
      phone: null,
      email: null,
    },
    buildingName: undefined,
    floor: undefined,
    nonGarageSpaces: undefined,
    propertyStyle: undefined,
    propertyStyles: undefined,
    propertyStyleOther: undefined,
    propertyTypeOther: undefined,
    renovationType: undefined,
    hasAdditionalLivingSpace: undefined,
    additionalLivingSpaceSqFt: undefined,
    county: undefined,
    smartResult: undefined,
  };
};
